(() => {
  'use strict';
  const money = cents => '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  // Amounts in Shopify Ajax currency units (JPY × 100).
function giftState(cart, includedProductId = '10757741674661') {
  const total = Math.max(0, Number(cart.total_price) || 0);
  const included = (cart.items || []).some(item => String(item.product_id) === String(includedProductId) && item.quantity > 0);
  const first = included ? 'ミルクチャイ1杯分' : '旨出汁コーレーグース1点';
  const target = total >= 1000000 ? 1500000 : 1000000;
  return { total, first, target, remaining: Math.max(0, target - total), firstEarned: total >= 1000000, sokiEarned: total >= 1500000, visible: total > 0 && (!cart.currency || cart.currency === 'JPY') };
}

  class GiftBenefit extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      document.addEventListener('cart:change', event => {
        if (event.detail?.cart) this.update(event.detail.cart);
      }, {signal: this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
    update(cart) {
      const state = giftState(cart, this.dataset.includedProduct);
      this.hidden = !state.visible;
      this.querySelector('[data-gift-earned]').hidden = !state.firstEarned;
      const earned = this.querySelector('[data-gift-earned-text]');
      earned.replaceChildren(document.createTextNode(state.first + 'をプレゼント'));
      if (state.sokiEarned) earned.append(document.createElement('br'), document.createTextNode('さらに ソーキそば1食をプレゼント'));
      this.querySelector('[data-gift-next]').hidden = !state.remaining;
      this.querySelector('[data-gift-remaining]').textContent = money(state.remaining);
      this.querySelector('[data-gift-next-name]').textContent = state.firstEarned ? 'ソーキそば1食' : state.first;
      const bar = this.querySelector('[data-gift-progress]');
      bar.max = state.target; bar.value = Math.min(state.total, state.target);
    }
  }
  if (!customElements.get('kazu-gift-benefit')) customElements.define('kazu-gift-benefit', GiftBenefit);

  class Benefit extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      document.addEventListener('cart:change', event => {if(event.detail?.cart) this.update(event.detail.cart.total_price)}, {signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort()}
    update(total){
      const benefit = total>=2000000?1500:total>=1500000?1000:total>=1000000?500:0;
      const target = total>=1500000?2000000:total>=1000000?1500000:1000000;
      const next = target===2000000?1500:target===1500000?1000:500;
      const remaining=Math.max(0,target-total), achieved=this.querySelector('[data-benefit-achieved]'), message=this.querySelector('[data-benefit-next]'), bar=this.querySelector('progress');
      achieved.hidden=!benefit; achieved.textContent=`送料${benefit===1500?'最大':''}${benefit.toLocaleString('ja-JP')}円引きの対象です`;
      message.hidden=!remaining; message.textContent=`あと${money(remaining)}で送料${next===1500?'最大':''}${next.toLocaleString('ja-JP')}円引き`;
      bar.max=target;bar.value=Math.min(total,target); this.hidden=total<=0;
    }
  }
  class Pairing extends HTMLElement {
    connectedCallback(){
      if(this.dataset.context!=='product')return;
      this.abort?.abort();this.abort=new AbortController();
      this.owner=this.closest('kazu-soba-product');
      this.owner?.addEventListener('change',()=>this.update(),{signal:this.abort.signal});
      this.addEventListener('click',e=>{const button=e.target.closest('[data-kazu-pair]');if(button)this.add(button)},{signal:this.abort.signal});this.update();
      // 2026-10-06：/cart へ移ったあと「戻る」で bfcache から戻ったら、押せる状態に戻す
      window.addEventListener('pageshow',e=>{if(!e.persisted)return;this.busy=false;this.querySelectorAll('[data-kazu-pair]').forEach(b=>b.disabled=false);const error=this.querySelector('[data-pair-error]');if(error)error.hidden=true},{signal:this.abort.signal});
    }
    disconnectedCallback(){this.abort?.abort()}
    selection(){const form=document.getElementById(this.querySelector('[data-kazu-pair]')?.dataset.form);const input=form?.querySelector('[data-soba-variant]:checked');const quantity=Number(form?.querySelector('[name="quantity"]')?.value);return {form,input,quantity}}
    update(){const {input,quantity}=this.selection();if(!input||!Number.isInteger(quantity)||quantity<1)return;this.querySelectorAll('[data-pair-total]').forEach(el=>el.textContent=`合わせて${Number(input.dataset.meals)*quantity+3}食 ${money(Number(input.dataset.price)*quantity+Number(el.dataset.addPrice))}（税込・送料別）`)}
    async add(button){
      if(this.busy)return;const {form,input,quantity}=this.selection();if(!input||!form.reportValidity()||!Number.isInteger(quantity)||quantity<1)return;
      this.busy=true;const buttons=[...this.querySelectorAll('[data-kazu-pair]')];buttons.forEach(b=>b.disabled=true);const error=this.querySelector('[data-pair-error]');error.hidden=true;
      // 2026-10-06 決定9：「カートに追加する」と同じく引き出しカートを開く（kz-buy.js と同じ形）。2点を1回で送るので、入ったか分からないときは再送せず /cart を開く。
      // 4xx は送る前と後の /cart.js の数を比べ、どちらも増えていなければ「断られた」として、ここに Shopify の説明を出してボタンを戻す（前の版と同じ見え方）
      const root=document.documentElement,base=window.Shopify?.routes?.root||'/',settings=window.themeVariables?.settings||{};
      const wait=ms=>(window.AbortSignal&&AbortSignal.timeout?AbortSignal.timeout(ms):undefined);
      const quantities=async()=>{try{const r=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store',signal:wait(8000)});if(!r.ok)return null;const c=await r.json();const m=new Map();(c.items||[]).forEach(l=>m.set(l.variant_id,(m.get(l.variant_id)||0)+l.quantity));return m}catch(_){return null}};
      const items=[{id:Number(input.value),quantity},{id:Number(button.dataset.variant),quantity:1}];
      let leaving=false,rejected=false;
      try{
        const before=await quantities();
        const sections=[];
        if(settings.cartType!=='page')root.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));
        const response=await fetch(base+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items,sections:[...new Set(sections)].slice(0,5),sections_url:location.pathname}),signal:wait(20000)});
        const data=await response.json().catch(()=>({}));
        if(!response.ok){
          if(before&&response.status>=400&&response.status<500){const after=await quantities();rejected=!!after&&items.every(i=>(after.get(i.id)||0)<=(before.get(i.id)||0));}
          throw new Error(data.description||'カートへ追加できませんでした');
        }
        if(settings.cartType==='page'){leaving=true;location.assign(base+'cart');return;}
        const cartResponse=await fetch(base+'cart.js',{credentials:'same-origin',cache:'no-store',signal:wait(12000)});
        if(!cartResponse.ok)throw new Error('cart-refresh');
        const cart=await cartResponse.json();
        if(!sections.length||sections.some(id=>!data.sections?.[id]))throw new Error('section-refresh');
        cart.sections=data.sections;
        root.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',onSuccessDo:'force_open_drawer',cart}}));
      }catch(e){
        if(rejected){error.textContent=e.message;error.hidden=false;}
        else{leaving=true;error.textContent='入ったかを確かめるため、カートを開きます';error.hidden=false;location.assign(base+'cart');}
      }finally{
        if(!leaving){this.busy=false;buttons.forEach(b=>b.disabled=false);}
      }
    }
  }
  if(!customElements.get('kazu-shipping-benefit'))customElements.define('kazu-shipping-benefit',Benefit);
  if(!customElements.get('kazu-pairing'))customElements.define('kazu-pairing',Pairing);
})();
